<script setup lang="ts">
import BaseModal from '@/application/components/BaseModal.vue';
import type { BankAccount } from '@/api/bankAccount/types';
import EditBankAccount from "@/user/components/EditBankAccount.vue";

defineProps<{ show: boolean, bankAccount: BankAccount }>();
const emit = defineEmits(['update:show']);
</script>

<template>
  <BaseModal
    :show="show"
    height="92%"
    title="Bankverbindung bearbeiten"
    @close="emit('update:show', false)"
  >
    <EditBankAccount v-if="show" :bank-account="bankAccount" @close="emit('update:show', false)" />
  </BaseModal>
</template>
